export default function Cursor() {
	return (
		<div className='w-3 h-3 bg-gray-500 rounded-full' />
	)
}
